import {AbilityContextProvider} from '@modifi/plugin-authorization'
import React, {useEffect} from 'react'
import {Container, Row, Col} from '@modifi/ui'
import {AnnouncementBanner} from '@modifi/plugin-banners'

import {abilityFactory} from '../constants/permissions'

import Header from './header'
import GlobalStyle from './globalStyle'
import {StyledModifiUiApp} from './styles'

const ability = abilityFactory()

type LayoutProps = {
  children?: React.ReactNode
  loading?: boolean
  fetchAnnouncements: (locale: string, key: string) => void
  locale: string
  announcementToDisplay?: {
    expiry: string
  }
}

const Layout: React.FC<LayoutProps> = ({
  children = null,
  loading = false,
  fetchAnnouncements,
  locale,
  announcementToDisplay = undefined,
}) => {
  useEffect(() => {
    fetchAnnouncements(locale, 'riskOnboarding')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchAnnouncements])

  if (loading) {
    return null
  }
  return (
    <AbilityContextProvider ability={ability}>
      <StyledModifiUiApp>
        <Header />
        {children && (
          <Container mt={80} fluid>
            {announcementToDisplay && announcementToDisplay?.expiry && (
              <Row mt={16}>
                <Col>
                  <AnnouncementBanner />
                </Col>
              </Row>
            )}

            {children}
          </Container>
        )}
        <GlobalStyle />
        <div id="portalForDrawer" />
      </StyledModifiUiApp>
    </AbilityContextProvider>
  )
}

export default Layout
